import { useMemo } from 'react';
import { format } from 'date-fns';
import { HistoryResultCard } from '@/features/Vacations/components/VacationHistoryResultsCards/components/HistoryResultCard';
import { buildHistoryDemoRows } from './historyDemo.definitions';

export const HISTORY_DEMO_KIND = 'started' as const;

export function TourDemoHistoryResults() {
    const { rows, periodKey } = useMemo(() => {
        const today = new Date();
        return { rows: buildHistoryDemoRows(today), periodKey: format(today, 'yyyy-MM') };
    }, []);

    return (
        <div className="grid grid-cols-1 gap-4">
            {rows.map((row, index) => (
                <div
                    key={row.requestId ?? 'manual'}
                    data-tour={index === 0 ? 'history-card' : row.isManual ? 'history-manual-card' : undefined}
                >
                    <HistoryResultCard
                        row={row}
                        kind={HISTORY_DEMO_KIND}
                        periodFilterKey={periodKey}
                        highlightedKind={HISTORY_DEMO_KIND}
                        defaultTimelineOpen={index === 0}
                        timelineTourTarget={index === 0 ? 'history-timeline' : undefined}
                    />
                </div>
            ))}
        </div>
    );
}

export default TourDemoHistoryResults;
